import { api } from './api';
import { Session } from '@/types';

type Token = {
  token: string;
};

const sessionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    session: builder.query<Session, void>({
      query: () => 'authenticate',
      providesTags: ['Session'],
    }),
    token: builder.mutation<Token, void>({
      query: () => ({
        url: 'token',
        method: 'POST',
      }),
      onQueryStarted: async (emissions, { queryFulfilled }) => {
        const { data } = await queryFulfilled;
        localStorage.setItem('kinesis:session', data.token);
      },
      invalidatesTags: ['Session'],
    }),
    logout: builder.mutation<Token, void>({
      query: () => ({
        url: 'logout',
        method: 'POST',
      }),
      onQueryStarted: async (emissions, { queryFulfilled, dispatch }) => {
        await Promise.all([queryFulfilled, dispatch(api.util.resetApiState())]);
        localStorage.removeItem('kinesis:session');
        window.location.assign('/');
      },
    }),
  }),
});

export const { useSessionQuery, useTokenMutation, useLogoutMutation } =
  sessionApi;

export { sessionApi };
